import { render, staticRenderFns } from "./ListUsuarios.vue?vue&type=template&id=f128485e&"
import script from "./ListUsuarios.vue?vue&type=script&lang=js&"
export * from "./ListUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./ListUsuarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports